import React, { useState } from 'react';

import {
  CmAddIconButton,
  CmBox,
  CmFlex,
  CmStack,
  CmText,
} from '@/components/uiParts';
import { ChevronDownIcon } from '@/components/uiParts';
import { DeliveryServiceName } from '@/domain/models/DeliveryService';
import { LinkedStoreItem, LinkItem } from '@/domain/models/LinkItem';
import { ommisionText } from '@/lib/util';
import { uniqueLinkedStoreItemId } from '@/pages/link-items/function';

interface Props {
  uniqueLinkedStoreItemIdsByGroups: string[];
  isDisabledAddButton: boolean;
  linkItem: LinkItem;
  deliveryServiceName: DeliveryServiceName;
  handleAddItemToLinkedGroup: (linkedStoreItem: LinkedStoreItem) => void;
}

const MAX_DISPLAY_STORE_NAME_TEXT_NUM = 100;

export const AccordionItem: React.FC<Props> = ({
  uniqueLinkedStoreItemIdsByGroups,
  isDisabledAddButton,
  linkItem,
  deliveryServiceName,
  handleAddItemToLinkedGroup,
}) => {
  const [isOpenStoreList, setIsOpenStoreList] = useState<boolean>(false);

  const isIncludedGroupItem = (() => {
    return uniqueLinkedStoreItemIdsByGroups.some((uniqueIdByGroups) =>
      linkItem.linked_store_items.some(
        (linkedStoreItem) =>
          uniqueLinkedStoreItemId(
            linkedStoreItem.external_item_id,
            linkedStoreItem.store_id,
            linkItem.item_name
          ) === uniqueIdByGroups
      )
    );
  })();

  const uniqueItemId = `${deliveryServiceName}-${linkItem.item_name}`;

  const JoinedStoreNames = linkItem.linked_store_items
    .map((linkedStoreItem) => linkedStoreItem.store_name)
    .join('、');

  const displayLinkStoreNames = (() => {
    const maxNum = isOpenStoreList ? Infinity : MAX_DISPLAY_STORE_NAME_TEXT_NUM;

    return ommisionText(JoinedStoreNames, maxNum);
  })();

  return (
    <CmFlex
      align="flex-start"
      alignItems="center"
      justifyContent="space-between"
      fontSize="lg"
      py="3"
      pl="8"
      pr="2"
      borderTopWidth="1px"
      bg="white"
    >
      <CmStack spacing="5px" w="full">
        <CmFlex pr="2">
          <CmText fontWeight="bold" w={'135px'}>
            商品名
          </CmText>
          <CmText w="calc(100% - 120px)" ml="10px">
            {linkItem.item_name}
          </CmText>
        </CmFlex>
        {linkItem.linked_store_items.length > 0 && (
          <CmFlex pr="2">
            <CmText fontWeight="bold" w={'135px'}>
              店舗名一覧
            </CmText>
            <CmText w="calc(100% - 120px)" ml="10px">
              {displayLinkStoreNames}
              {JoinedStoreNames.length > MAX_DISPLAY_STORE_NAME_TEXT_NUM && (
                <CmBox
                  as="span"
                  display="block"
                  cursor="pointer"
                  textAlign="center"
                  onClick={() => {
                    setIsOpenStoreList((prev) => !prev);
                  }}
                >
                  <ChevronDownIcon
                    transition="0.3s"
                    fontSize="30px"
                    transform={`rotate(${isOpenStoreList ? '0' : '-180deg'})`}
                  />
                </CmBox>
              )}
            </CmText>
          </CmFlex>
        )}
        {linkItem.group_name && (
          <CmFlex pr="2">
            <CmText fontWeight="bold" w={'135px'}>
              追加グループ名
            </CmText>
            <CmText w="calc(100% - 120px)" ml="10px">
              {linkItem.group_name}
            </CmText>
          </CmFlex>
        )}
      </CmStack>
      <CmAddIconButton
        aria-label="商品を追加"
        id={uniqueItemId}
        isDisabled={isIncludedGroupItem || isDisabledAddButton}
        onClick={() =>
          handleAddItemToLinkedGroup({
            delivery_service_name: deliveryServiceName,
            item_name: linkItem.item_name,
            item_ids: linkItem.linked_store_items,
          })
        }
      />
    </CmFlex>
  );
};
